/**
 * Generates and downloads the blank Excel template used by the Vendor Master
 * MOQ/MOV upload flow. Headers match exactly the column names the backend SP
 * dbo.ImportVendorOrderType expects (VendorName, JobType, OrderType, MOQ, MOV).
 *
 * Pattern mirrors helper/downloadOrderUploadTemplate.ts — Workbook (exceljs) and
 * fs (file-saver) are injected so this helper doesn't carry hard imports of
 * those packages.
 */
export const downloadMoqMovUploadTemplate = (
  Workbook: any,
  fs: any
) => {
  let workbook = new Workbook();
  let worksheet = workbook.addWorksheet('MOQ MOV Upload');
  let columns = getColumnDefs();
  worksheet.columns = columns as any;
  worksheet.getRow(1).font = { bold: true };
  worksheet.getRow(1).fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'cccccc' },
  };
  workbook.xlsx.writeBuffer().then((data: any) => {
    let blob = new Blob([data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    fs.saveAs(blob, `MOQ_MOV_UploadTemplate_${new Date().toISOString()}.xlsx`);
  });
};

function getColumnDefs() {
  const headerStyle = {
    border: {
      top: { style: 'thin', color: { argb: '000000' } },
      left: { style: 'thin', color: { argb: '000000' } },
      bottom: { style: 'thin', color: { argb: '000000' } },
      right: { style: 'thin', color: { argb: '000000' } },
    },
    fill: {
      type: 'pattern',
      gradient: 'lightGray',
      bgColor: { argb: '808080' },
    },
  };

  const columns = [
    { header: 'VendorName', key: 'vendorName', width: 40, style: headerStyle },
    { header: 'JobType',    key: 'jobType',    width: 18, style: headerStyle },
    { header: 'OrderType',  key: 'orderType',  width: 18, style: headerStyle },
    { header: 'MOQ',        key: 'moq',        width: 12, style: headerStyle },
    { header: 'MOV',        key: 'mov',        width: 12, style: headerStyle },
  ];
  return columns;
}
